import { useContext } from 'react';
import useArticle from './useArticle';
import useHome from './useHome';
import { CategoryContext } from '../contexts';
import { ICategory } from '../types';

export default function useCategory(
  categoryId?: string
): ICategory | undefined {
  const home = useHome();
  const category = useContext(CategoryContext);
  const article = useArticle();

  if (!categoryId) {
    if (category) return category;
    if (article) return article.category;
    return undefined;
  }

  if (home && home.categories) {
    const _category = home.categories.find(c => c.id === categoryId);
    if (_category) return _category;
  }

  return undefined;
}
